var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.43 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.26,60h-.05c-1.09,0-2.09-.22-3.03-.67C4.35,50.23.71,25.24.01,14.92c-.15-2.24.82-3.92,2.89-4.97C5.95,8.41,19.01,2.6,22.95.85c.71-.32,1.9-.85,3.12-.85h.31c1.22,0,2.41.53,3.12.85,2.78,1.23,16.85,7.48,20.04,9.09,2.07,1.06,3.04,2.73,2.89,4.98-.68,10.32-4.32,35.31-23.16,44.41-.94.45-1.95.67-3,.67Zm-.09-58.18c-.94,0-1.9.43-2.47.69-3.93,1.74-16.96,7.54-19.96,9.06-1.42.72-2,1.72-1.9,3.23.67,10,4.17,34.21,22.14,42.89.68.33,1.43.49,2.21.49h.08c.78,0,1.52-.17,2.21-.49,17.97-8.68,21.46-32.88,22.13-42.89.1-1.52-.48-2.51-1.9-3.23-2.44-1.23-12.27-5.65-19.95-9.05-.58-.26-1.55-.7-2.38-.7h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.52,43.42h-12.62l1.49-10.98c-1.84-1.46-2.92-3.68-2.92-6.06,0-4.27,3.47-7.75,7.73-7.75s7.74,3.48,7.74,7.75c0,2.37-1.08,4.6-2.92,6.06l1.49,10.98Zm-10.54-1.82h8.46l-1.36-10,.46-.32c1.62-1.1,2.59-2.93,2.59-4.9,0-3.27-2.66-5.93-5.92-5.93s-5.91,2.66-5.91,5.93c0,1.96.96,3.79,2.58,4.9l.46.32-1.36,10Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessIcon);
export default __webpack_public_path__ + "static/media/access-icon.8844007690e52136658db0720d0abd9b.svg";
export { ForwardRef as ReactComponent };